import styled from 'styled-components';
import { space } from 'shared';
import Container from 'components/Container';

export const HeaderWrapper = styled.header`
  background-color: ${({ theme }) => theme.white};
  height: 84px;
  min-height: 84px;
  overflow: visible;
  z-index: ${({ isDropdownOpen }) => (isDropdownOpen ? 10 : 1)};
`;

export const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  padding: ${space(18, 12)};
`;

export const UserPanel = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const HeaderLogo = styled.img`
  height: 38px;
`;

// Namensanzeige waehrend eines offenen Loeschvorgangs. Dort ist currentUser
// gesperrt (403), das ganze UserPanel entfaellt -- es bleibt der Name allein,
// ohne Avatar, Rollen-Badge und Aufklapp-Menue.
export const LockedUserName = styled.span`
  align-self: center;
  color: ${({ theme }) => theme.secondary};
  /* RENDER-NEUTRAL getokent: das fontWeight-Mapping ist nicht-standard, 600 ist
     fontWeightUpperBold -- NICHT fontWeightSemiBold (das waere 500 und wuerde die
     Darstellung aendern). Das Token-Gate stand durch das rohe 600 auf 1. */
  font-weight: ${({ theme }) => theme.fontWeightUpperBold};
`;
